import { Component } from 'react'
import { connect } from 'react-redux'
import { PROPOSALS_TO_REVIEW_FETCH_REQ } from '../actions'
import { ProposalsReviewTemplate } from 'components/Dashboard/ProposalsReviewTemplate'
import { fromProposals } from '../serializers'

@connect(({ dashboard }) => {
  return {
    dashboard
  }
})
class ProposalsToReviewContainer extends Component {
  componentDidMount() {
    this.props.dispatch({
      type: PROPOSALS_TO_REVIEW_FETCH_REQ
    })
  }

  render() {
    return (
      <ProposalsReviewTemplate
        title="Proposals I Need to Review"
        subTitle="Below is a list of opportunities I have proposals to review before submission to client"
        proposals={fromProposals(this.props.dashboard.proposalsINeedToReview)}
      />
    )
  }
}

export default ProposalsToReviewContainer
